module.exports = __webpack_public_path__ + "static/img/afterSalesHeader@3xcb48634.png";